import { z } from "zod";
import { memberIdSchema } from "./common.schemas";
import { newCanonicalSchema } from "./entity-id.schemas";

const canonicalUrlSchema = z
  .string()
  .url()
  .refine((value) => !value.includes("|"), "Protocol url must not contain a version pin");

const sessionContentSchema = z.object({
  timeWindow: z.enum(["early_morning", "mid_morning", "midday", "early_afternoon", "late_afternoon"]),
  protocol: z.object({ definitionUrl: canonicalUrlSchema }),
});

const defineSessionSchema = sessionContentSchema.strict();
const reviseSessionSchema = sessionContentSchema.extend({ id: memberIdSchema.optional() }).strict();
const defineDaysSchema = z.array(z.object({ sessions: z.array(defineSessionSchema).min(1) }).strict()).min(1);
const reviseDaysSchema = z
  .array(z.object({ id: memberIdSchema.optional(), sessions: z.array(reviseSessionSchema).min(1) }).strict())
  .min(1);

export const defineProgramDefinitionInputSchema = z.object({
  definitionUrl: newCanonicalSchema,
  name: z.string().trim().min(1),
  description: z.string().trim().min(1).optional(),
  days: defineDaysSchema,
});
export type DefineProgramDefinitionInput = z.infer<typeof defineProgramDefinitionInputSchema>;

export const reviseProgramDefinitionInputSchema = z.object({
  definitionUrl: canonicalUrlSchema,
  expectedVersion: z.number().int().positive(),
  days: reviseDaysSchema,
});
export type ReviseProgramDefinitionInput = z.infer<typeof reviseProgramDefinitionInputSchema>;

export const correctProgramDefinitionInputSchema = z.object({
  definitionUrl: canonicalUrlSchema,
  name: z.string().trim().min(1).optional(),
  description: z.string().trim().min(1).nullable().optional(),
});
export type CorrectProgramDefinitionInput = z.infer<typeof correctProgramDefinitionInputSchema>;

export const changeProgramDefinitionAvailabilityInputSchema = z.object({ definitionUrl: canonicalUrlSchema });
export type ChangeProgramDefinitionAvailabilityInput = z.infer<typeof changeProgramDefinitionAvailabilityInputSchema>;
